import React, { Fragment } from 'react'
import { withRouter } from 'react-router'
import Cookies from 'js-cookie'

import Component from 'components/component'
import { Modal } from 'components/modal'
import { DI } from 'modules'
import getAcceptedCookies from '../../../../helpers/cookies'
import FirstTimeInteractionPopup from './first-time-interaction-popup'

const FOLLOW_POPUP_COOKIE_KEY = 'live_notify_follow'

export class FollowEvent extends Component {
  state = {
    modalOpened: false,
  }

  toggleSubscribed() {
    const { slug, subscribed } = this.props.liveEvent

    this.props.actions.lives.changeSubscription(slug, !subscribed).then(() => {
      this.setState({ modalOpened: false })
    })
  }

  string(key) {
    return this.props.common.strings[`page.lives.view.follow.${key}`]
  }

  cancelPopup = () => {
    const cookiesList = getAcceptedCookies()
    if (cookiesList && cookiesList.functional) {
      Cookies.set(FOLLOW_POPUP_COOKIE_KEY, 'cancel', { expires: 45 })
    }
    this.toggleSubscribed()
  }

  approvePopup = () => {
    const cookiesList = getAcceptedCookies()
    if (cookiesList && cookiesList.functional) {
      Cookies.set(FOLLOW_POPUP_COOKIE_KEY, 'approve', { expires: 45 })
    }
    this.props.actions.user
      .updateCurrentUser({ live_notify: true })
      .then(() => {
        this.toggleSubscribed()
      })
  }

  popupNeeded() {
    return (
      !this.props.user.currentUser.payload.live_notify &&
      !Cookies.get(FOLLOW_POPUP_COOKIE_KEY)
    )
  }

  closePopup() {
    this.setState({ modalOpened: false })
  }

  subscribe = () => {
    if (this.popupNeeded()) {
      this.setState({ modalOpened: true })
    } else {
      this.toggleSubscribed()
    }
  }

  render() {
    const liveEvent = this.props.liveEvent

    const buttonClassName = Component.classList(
      'button',
      typeof liveEvent?.subscribed === 'undefined' ? '_waiting' : undefined
    )

    return (
      <Fragment>
        <span className="live__reminder">{this.string('description')}</span>
        <div className="live-login">
          <button
            type="button"
            className={buttonClassName}
            onClick={this.subscribe}
          >
            {this.string('button')}

            {!!liveEvent.subscribed && <span className="_success" />}
          </button>
        </div>
        {this.state.modalOpened && (
          <Modal onClose={this.closePopup}>
            <div className="popup-tip">
              <span className="popup__title">{this.string('popup.title')}</span>
              <div className="popup__tip">{this.string('popup.body')}</div>
              <div className="popup-buttons">
                <div className="popup-button">
                  <button
                    onClick={this.cancelPopup}
                    type="button"
                    className="text-button"
                  >
                    {this.string('popup.btn_no')}
                  </button>
                </div>
                <div className="popup-button">
                  <button
                    type="button"
                    onClick={this.approvePopup}
                    className="button"
                  >
                    {this.string('popup.btn_yes')}
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        )}
        {liveEvent.subscribed && <FirstTimeInteractionPopup />}
      </Fragment>
    )
  }
}

export default withRouter(DI(['lives', 'common', 'user'])(FollowEvent))
